import { BASE_URL } from "config";

import * as base from './_base';


export const endpoints = {
  list: `${BASE_URL}/api/v1/district/`,
  detail: (id) => `${BASE_URL}/api/v1/district/${id}/`,
};

export const districtListLoad = (token, payload) => base.ListLoad(endpoints.list, token, payload);
export const districtDetailLoad = (token, { id }) => base.DetailLoad(endpoints.detail, token, { id });
export const districtUpdate = (token, data) => base.Update(endpoints.list, endpoints.detail, token, data);
export const districtDelete = (token, data) => base.Delete(endpoints.detail, token, data);
